import LegalPageLayout from './LegalPageLayout';

function LegalNotice() {
    return <LegalPageLayout nsKey="legalNotice" />;
}

export default LegalNotice;
